import { PHONEME_DATA_LIST, TROUBLE_PHONEME_BY_LANGUAGE } from "./constants";

export const refreshHighlight = (selectedLanguageCode: any, mySoundPhonemes: any) => {
  if (selectedLanguageCode == "0") {
    // my sounds?
    // map phoneme to oid
    const oidArray = [];
    for (let i = 0; i < mySoundPhonemes.length; i++) {
      const phoneme = mySoundPhonemes[i];
      for (let j = 0; j < PHONEME_DATA_LIST.length; j++) {
        if (PHONEME_DATA_LIST[j].phoneme === phoneme) {
          oidArray.push(PHONEME_DATA_LIST[j].Id);
        }
      }
    }
    return oidArray;
  } else if (selectedLanguageCode == "1") {
    // "select a language"?
    // do nothing
  } else {
    // some language
    const oidArray = TROUBLE_PHONEME_BY_LANGUAGE[selectedLanguageCode];
    return oidArray;
  }
};
